export default "__VITE_ASSET__0b49026d__"